/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsControllerFindAllCountQueryResponse,
  TelegramProductsControllerFindAllCountQueryParams,
  TelegramProductsControllerFindAllCount401,
} from '../../types/TelegramProductsControllerFindAllCount.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsFindAllCount } from '../../methods/telegramProductsFindAllCount.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsFindAllCountQueryKey = (params?: TelegramProductsControllerFindAllCountQueryParams) =>
  [{ url: '/api/telegram/products/count' }, ...(params ? [params] : [])] as const;

export type TelegramProductsFindAllCountQueryKey = ReturnType<typeof telegramProductsFindAllCountQueryKey>;

export function telegramProductsFindAllCountQueryOptions(
  params?: TelegramProductsControllerFindAllCountQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsFindAllCountQueryKey(params);
  return queryOptions<
    TelegramProductsControllerFindAllCountQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindAllCount401>,
    TelegramProductsControllerFindAllCountQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsFindAllCount(params, config);
    },
  });
}

/**
 * {@link /api/telegram/products/count}
 */
export function useTelegramProductsFindAllCount<
  TData = TelegramProductsControllerFindAllCountQueryResponse,
  TQueryData = TelegramProductsControllerFindAllCountQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsFindAllCountQueryKey,
>(
  params?: TelegramProductsControllerFindAllCountQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsControllerFindAllCountQueryResponse,
        ResponseErrorConfig<TelegramProductsControllerFindAllCount401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsFindAllCountQueryKey(params);

  const query = useQuery(
    {
      ...telegramProductsFindAllCountQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsControllerFindAllCount401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
